// Dependencies 
import { useContext, useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import DropdownIndicator from 'react-select';
import AsyncSelect from 'react-select/async';
import _ from 'lodash';
import { useField } from "formik";

// Contexts
import AppContext from '../../contexts/AppContext';

// Types
import { Components, Types } from "../../utils/types";
import useAPI from '../../hooks/Api';

export const DropdownSelect = ({ name, value, type, autocomplete, options, placeholder, source }: Components.DropdownSelect) => {
    
    const [activeOptions, setActiveOptions] = useState<Types.DropdownOption[]>(options);
    const [field, meta, helpers] = useField({name, type});
    const optionsRef = useRef<any>(options);

    const { getCitiesList } = useAPI();

    const getSelectedValue = options.find( (option: Types.DropdownOption) => option.value === meta.value );

    const handleSelect = ({value}: any) => {
        
        // TODO:    Support for multiselect and rethink types..

        switch ( type ) {

            case 'dropdown':
                if ( meta.value !== value ) {
                    helpers.setValue( value );  // NOTE:    Had to remove ability to deselect radio field (conditional logic applied after many renders)
                }
                return;

        }
        
    }

    const handleInput = (value: string) => {
        if ( autocomplete && ! _.isEmpty( optionsRef.current ) ) {
            let filteredOptions = optionsRef.current.filter((option: any) => option.value.toLowerCase().includes(value.toLowerCase()))
            setActiveOptions( _.isEmpty(value) ? filteredOptions.slice(0, 10) : filteredOptions );
        }
    }

    const handleMenuOpen = () => {

        // TODO: useRef
        requestAnimationFrame(() => {
            let scrollHeight = document.querySelector('.form__sections')?.scrollHeight;
            if ( scrollHeight ) {
                document.querySelector('.form__sections')?.scrollTo({behavior: 'smooth', top: scrollHeight - 450});
            }
        });
    }

    useEffect(() => {

        setTimeout(() => {
            handleMenuOpen();
        }, 10);

        if ( autocomplete ) {

            getCitiesList()
            .then(response => {
                
                optionsRef.current = response?.data.map((city: string) => ({
                    label: city,
                    value: city
                }));
                
                setActiveOptions( optionsRef.current.slice(0, 10) );

            })

        }
 
    }, [])
 
    return (  
        <Select
            defaultMenuIsOpen={true} 
            openMenuOnFocus={true}
            autoFocus={true}
            isSearchable={autocomplete ? true : false}
            value={getSelectedValue}
            onChange={handleSelect} 
            onInputChange={autocomplete ? handleInput : undefined}
            classNamePrefix="dropdown"
            className="options__wrapper"
            components={{
                IndicatorSeparator: null
            }}
            onMenuOpen={handleMenuOpen}
            noOptionsMessage={() => "Nenašli sa žiadne výsledky."}
            placeholder={placeholder ?? "Vybrať..."}
            defaultValue={ 
                value 
                    ? options.find( (option: Types.DropdownOption) => option.value === value )
                    : null
            }
            
            options={activeOptions} />
    )

}